import { useSelector } from 'react-redux';

export const useTeam = () => {
    return useSelector(({ team: { team } }) => team);
};

export const useTeamLoading = () => {
    return useSelector(({ team: { loading } }) => loading);
};
